import { styled } from '@sds-system/system';
import { getAllStyledProps, mediaQuery } from '@sds-system/utils';
import type {
  AlertModalContentProps,
  AlertModalRootStyledOptions,
  AlertModalTitleWrapperProps,
} from './AlertModal.types';

export const StyledAlertModalRoot = styled('div', {
  componentName: 'AlertModal',
  slot: 'root',
})<AlertModalRootStyledOptions>(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    justifyContent: 'space-between',
  },
  getAllStyledProps,
);

export const StyledAlertModalTitleWrapper = styled('div', {
  componentName: 'AlertModal',
  slot: 'title',
})<AlertModalTitleWrapperProps>(
  ({ theme, isResponsive }) => ({
    color: theme.palette.text.primary,
    textAlign: 'center',
    ...theme.typography.header3.bold,
    ...(isResponsive &&
      mediaQuery(
        {
          fontType: ['header3.bold', 'header2.bold'],
        },
        theme,
      )),
  }),
  ...getAllStyledProps,
);

export const StyledAlertModalContentWrapper = styled('div', {
  componentName: 'AlertModal',
  slot: 'content',
})<AlertModalContentProps>(
  ({ textAlign, theme, isResponsive }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: theme.palette.text.secondary,
    ...(textAlign && { textAlign }),
    ...theme.typography.body2.regular,
    ...(isResponsive &&
      mediaQuery(
        {
          fontType: ['body2.regular', 'body.regular'],
        },
        theme,
      )),
  }),
  ...getAllStyledProps,
);
